<form [formGroup]="form" (ngSubmit)="save()">
  <h1 mat-dialog-title>Cambio de médico y equipo</h1>
  <div mat-dialog-content>
    <mat-form-field class="full-control">
      <input type="text" #equipment matInput placeholder="Equipo" formControlName="Equipment" [matAutocomplete]="autEquipment">
      <mat-autocomplete #autEquipment="matAutocomplete" [displayWith]="filterCompleteEquipments.displayFn">
        <mat-option *ngFor="let equipment of filteredEquipmentsOptions | async" [value]="equipment">
          {{equipment.Name}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field class="full-control">
      <input type="text" #physician matInput placeholder="Médico" formControlName="Physician" [matAutocomplete]="autPhysician">
      <mat-autocomplete #autPhysician="matAutocomplete" [displayWith]="filterCompletePhysicians.displayFn">
        <mat-option *ngFor="let physician of filteredPhysiciansOptions | async" [value]="physician">
          {{physician.Name}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>
  <div class="clearfix">
    <div class="pull-right">
      <button mat-button type="submit">Guardar</button>
      <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">Cancelar</button>
    </div>
  </div>
</form>


